import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, message } from "antd";
import { useEffect } from "react";
import { handleDeleteUser } from "../../../api/user";

export default function DeleteUser({
  isVisible,
  setVisible,
  user,
  company_id,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();


  const { mutate, isLoading } = useMutation({
    mutationFn: handleDeleteUser,
    onSuccess: () => {
      message.success("Removed Successfully");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["users", company_id],
      });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    await mutate({ _id: user?._id });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [user, form]);

  return (
    <Modal
      open={isVisible}
      title="Delete Member"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="deleteUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Remove
        </Button>,
      ]}
    >
      <Form
        id="deleteUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-automark-dark font-bold mx-1">Remove</span>
            Member
          </div>
          <div className="font-bold text-lg">{user?.name}?</div>
        </div>
      </Form>
    </Modal>
  );
}
